import { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import CardContainer from "../../../../components/Card/CardContainer";
import SectionHeader from "./SectionHeader";
import CompetitorsEditor from "../../../../components/BusinessCompetitors/CompetitorsEditor";
import {
  SECTION_COMPETITORS_TITLE,
  SECTION_COMPETITORS_SUBTITLE_SINGULAR,
  SECTION_COMPETITORS_SUBTITLE_PLURAL,
} from "../../../../i18n/keysTranslations";
import { BORDER_RADIUS } from "../../../../utils/constants";

export const CompetitorsSection = ({ formMethods, hasError = false }) => {
  const [isEditing, setIsEditing] = useState(false);

  if (!formMethods || !formMethods.control) {
    return null;
  }

  const {
    control,
    errors,
    watch,
    setValue,
    businessCompetitorsFields,
    appendBusinessCompetitors,
    removeBusinessCompetitors,
    validationRules,
  } = formMethods;

  const businessCompetitors = watch("businessCompetitors") || [];

  const onSave = () => {
    setIsEditing(false);
  };

  return (
    <CardContainer title="" hasError={hasError}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <SectionHeader
          icon={CorporateFareIcon}
          title={SECTION_COMPETITORS_TITLE}
          subtitleCount={businessCompetitorsFields.length}
          subtitleCountKeySingular={SECTION_COMPETITORS_SUBTITLE_SINGULAR}
          subtitleCountKeyPlural={SECTION_COMPETITORS_SUBTITLE_PLURAL}
          isEditing={isEditing}
          onEdit={() => setIsEditing(true)}
          onSave={onSave}
        />

        {isEditing ? (
          <CompetitorsEditor
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            businessCompetitorsFields={businessCompetitorsFields}
            appendBusinessCompetitors={appendBusinessCompetitors}
            removeBusinessCompetitors={removeBusinessCompetitors}
            validationRules={validationRules}
          />
        ) : (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            {businessCompetitors.map((competitor, index) => (
              <Chip
                key={index}
                label={competitor}
                sx={{
                  backgroundColor: "#F5F5F5",
                  color: "text.primary",
                  border: "none",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  borderRadius: BORDER_RADIUS,
                  px: 2,
                  py: 1.5,
                  height: "auto",
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </CardContainer>
  );
};

export default CompetitorsSection;
